var _defs, _path, _circle, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuseums(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a6b2b2;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "museums") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,0H16A16,16,0,0,0,0,15.92C0,26.83,14.3,42.85,14.9,43.55a1.45,1.45,0,0,0,2,0l0.05,0c0.6-.7,15-16.72,15-27.63A15.76,15.76,0,0,0,16.4,0h0ZM16,27.83a12,12,0,1,1,12-12A12,12,0,0,1,16,27.83Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 15.8,
    r: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.61,19.6H9.41A1.37,1.37,0,0,0,8,20.93S8,21,8,21v1a0.43,0.43,0,0,0,.4.4H23.5a0.43,0.43,0,0,0,.4-0.4V21.1a1.31,1.31,0,0,0-1.11-1.49H22.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.71,9.2l-7.5-2.8h-0.4L8.31,9.2a0.42,0.42,0,0,0-.3.4v1a0.43,0.43,0,0,0,.4.4h15.1a0.43,0.43,0,0,0,.4-0.4v-1C24.11,9.5,23.91,9.3,23.71,9.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.71,18.8h14.1a1.18,1.18,0,0,0-.9-0.9V13a1.18,1.18,0,0,0,.9-0.9H8.71a1.18,1.18,0,0,0,.9.9v4.9A1.06,1.06,0,0,0,8.71,18.8Zm8.7-5.7h1.9v4.7h-1.9V13.1Zm-4.9,0h1.9v4.7h-1.9V13.1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseums);
export default __webpack_public_path__ + "static/media/museums.a7d1171ba27ba7711c6f8a193291fa05.svg";
export { ForwardRef as ReactComponent };